import {
    CreateSurveyDispatchSchema,
    UpdateSurveyDispatchSchema,
} from '@repo/contracts';
import { withRetry } from '../utils/retry.js';

export class SurveyDispatchService {
    constructor(api, config = {}) {
        this.api = api;
        this.config = config;
    }

    async listByFormTemplate(formTemplateId) {
        try {
            const response = await withRetry(
                () => this.api.getAll({ formTemplateId }),
                { maxRetries: 2 },
            );
            return {
                success: true,
                data: response.data || [],
                message: response.message,
            };
        } catch (error) {
            throw this._handleError(error, 'Failed to list survey dispatches');
        }
    }

    async getById(id) {
        try {
            const response = await withRetry(() => this.api.getById(id), { maxRetries: 2 });
            return { success: true, data: response.data, message: response.message };
        } catch (error) {
            throw this._handleError(error, 'Failed to fetch survey dispatch');
        }
    }

    async create(data) {
        try {
            const parsed = CreateSurveyDispatchSchema.parse(data);
            const response = await this.api.create(parsed);
            return {
                success: true,
                data: response.data,
                run: response.run || null,
                message: response.message,
            };
        } catch (error) {
            throw this._handleError(error, 'Failed to create survey dispatch');
        }
    }

    async update(id, data) {
        try {
            const parsed = UpdateSurveyDispatchSchema.parse(data);
            const response = await this.api.update(id, parsed);
            return { success: true, data: response.data, message: response.message };
        } catch (error) {
            throw this._handleError(error, 'Failed to update survey dispatch');
        }
    }

    async delete(id) {
        try {
            const response = await this.api.delete(id);
            return { success: true, message: response.message };
        } catch (error) {
            throw this._handleError(error, 'Failed to delete survey dispatch');
        }
    }

    async runNow(id) {
        try {
            const response = await this.api.runNow(id);
            return {
                success: true,
                data: response.data,
                taskIds: response.taskIds || [],
                source: response.source,
                message: response.message,
            };
        } catch (error) {
            throw this._handleError(error, 'Failed to run survey dispatch');
        }
    }

    _handleError(error, fallback) {
        const err = new Error(error?.message || fallback);
        err.cause = error;
        err.status = error?.status;
        err.data = error?.data;
        return err;
    }
}
